var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 221,
    height: 204,
    viewBox: "0 0 221 204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 49,
    y: 0,
    width: 114,
    height: 167,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09ddff",
    floodOpacity: 0.361
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 75,
    y: 37,
    width: 114,
    height: 167,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09ddff",
    floodOpacity: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 0,
    y: 10,
    width: 110,
    height: 153,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09ddff",
    floodOpacity: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 135,
    y: 48,
    width: 86,
    height: 129,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#09ddff",
    floodOpacity: 0.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.5,
    x2: 0.502,
    y2: 0.997,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#255a7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a262b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 -23.368)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -10, 23.37)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(106 115)",
    fill: "#00ceff",
    fontSize: 76,
    fontFamily: "Gadugi-Bold, Gadugi",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.342,
    y: 0
  }, "P"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -10, 23.37)",
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(132 89) rotate(180)",
    fill: "#00ceff",
    fontSize: 76,
    fontFamily: "Gadugi-Bold, Gadugi",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.342,
    y: 0
  }, "P"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -10, 23.37)",
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(55 112)",
    fill: "#00ceff",
    fontSize: 71,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.265,
    y: 0
  }, "&lt;"))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -10, 23.37)",
    filter: "url(#g)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "translate(178 138)",
    fill: "#00ceff",
    fontSize: 71,
    fontFamily: "Montserrat-Bold, Montserrat",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.265,
    y: 0
  }, "&gt;"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78 130.833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.144,0,4.289,3.574,2.144,7.148,0,3.574Z",
    transform: "translate(3.714 10.241) rotate(-150)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.144,0,4.289,3.574,2.144,7.148,0,3.574Z",
    transform: "translate(8.623 9.288) rotate(-150)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.144,0,4.289,3.574,2.144,7.148,0,3.574Z",
    transform: "translate(13.532 8.335) rotate(-150)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.144,0,4.289,3.574,2.144,7.148,0,3.574Z",
    transform: "translate(3.714 15.733) rotate(-150)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.144,0,4.289,3.574,2.144,7.148,0,3.574Z",
    transform: "translate(8.623 14.676) rotate(-150)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.144,0,4.289,3.574,2.144,7.148,0,3.574Z",
    transform: "translate(13.532 13.619) rotate(-150)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.144,0,4.289,3.574,2.144,7.148,0,3.574Z",
    transform: "translate(3.714 21.017) rotate(-150)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.144,0,4.289,3.574,2.144,7.148,0,3.574Z",
    transform: "translate(8.623 20.064) rotate(-150)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.144,0,4.289,3.574,2.144,7.148,0,3.574Z",
    transform: "translate(13.532 19.111) rotate(-150)",
    fill: "url(#i)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(121.897 98.519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.144,0,4.289,3.574,2.144,7.148,0,3.574Z",
    transform: "translate(3.714 10.241) rotate(-150)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.144,0,4.289,3.574,2.144,7.148,0,3.574Z",
    transform: "translate(8.623 9.288) rotate(-150)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.144,0,4.289,3.574,2.144,7.148,0,3.574Z",
    transform: "translate(13.532 8.335) rotate(-150)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.144,0,4.289,3.574,2.144,7.148,0,3.574Z",
    transform: "translate(3.714 15.733) rotate(-150)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.144,0,4.289,3.574,2.144,7.148,0,3.574Z",
    transform: "translate(8.623 14.676) rotate(-150)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.144,0,4.289,3.574,2.144,7.148,0,3.574Z",
    transform: "translate(13.532 13.619) rotate(-150)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.144,0,4.289,3.574,2.144,7.148,0,3.574Z",
    transform: "translate(3.714 21.017) rotate(-150)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.144,0,4.289,3.574,2.144,7.148,0,3.574Z",
    transform: "translate(8.623 20.064) rotate(-150)",
    fill: "url(#i)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.144,0,4.289,3.574,2.144,7.148,0,3.574Z",
    transform: "translate(13.532 19.111) rotate(-150)",
    fill: "url(#i)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.403c01f07990596f8b9109012a949f3a.svg";
export { ForwardRef as ReactComponent };